import { useState } from "react";
import { useSearchParams, useNavigate, Link } from "react-router-dom";
import { toast } from "sonner";
import { api } from "@/lib/api";

export default function ResetPassword() {
  const [sp] = useSearchParams();
  const nav = useNavigate();
  const token = sp.get("token") || "";
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (password !== confirm) { toast.error("Passwords don't match."); return; }
    if (password.length < 8) { toast.error("Password must be at least 8 characters."); return; }
    setLoading(true);
    try {
      await api.post("/auth/reset-password", { token, password });
      setDone(true);
      toast.success("Password updated. You can sign in now.");
      setTimeout(() => nav("/auth"), 1500);
    } catch (err) {
      toast.error(err?.response?.data?.detail || "This reset link is invalid or expired.");
    } finally { setLoading(false); }
  };

  return (
    <div className="max-w-md mx-auto px-5 pt-12" data-testid="reset-password-page">
      <h1 className="font-display text-3xl sm:text-4xl font-black">Set a new password</h1>
      {!token ? (
        <p className="text-gray-300 mt-3 text-sm leading-relaxed" data-testid="reset-no-token">
          This link is missing its reset token. Request a new one from the <Link to="/auth" className="text-[#FD0F10] hover:underline">sign-in page</Link>.
        </p>
      ) : done ? (
        <p className="text-gray-300 mt-3 text-sm leading-relaxed" data-testid="reset-done">Your password is updated. Taking you to sign in…</p>
      ) : (
        <form onSubmit={submit} className="mt-8 space-y-4">
          <input value={password} onChange={e=>setPassword(e.target.value)} type="password" required minLength={8} placeholder="New password (8+ chars)" className="w-full bg-[#14161B] border border-[#2A2E39] rounded-lg px-4 py-3 focus:border-[#FD0F10] outline-none" data-testid="reset-password-input" />
          <input value={confirm} onChange={e=>setConfirm(e.target.value)} type="password" required minLength={8} placeholder="Confirm new password" className="w-full bg-[#14161B] border border-[#2A2E39] rounded-lg px-4 py-3 focus:border-[#FD0F10] outline-none" data-testid="reset-password-confirm" />
          <button disabled={loading} className="w-full hero-accent text-white font-display font-bold text-lg py-3.5 rounded-lg disabled:opacity-60" data-testid="reset-password-submit">{loading ? "..." : "UPDATE PASSWORD"}</button>
        </form>
      )}
    </div>
  );
}
